import { render, staticRenderFns } from "./ShortNote.vue?vue&type=template&id=142fc2fe&scoped=true"
import script from "./ShortNote.vue?vue&type=script&lang=js"
export * from "./ShortNote.vue?vue&type=script&lang=js"
import style0 from "./ShortNote.vue?vue&type=style&index=0&id=142fc2fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142fc2fe",
  null
  
)

export default component.exports